export const LOGIN_PAGE = 0;
export const MAIN_PAGE = 1;
export const SIGN_UP_PAGE = 2;
export const VALIDATE_PAGE = 3;
export const FORGOTTEN_PAGE = 4;
export const FORGOTTEN_PAGE_RESET = 5;
export const OPTIONS_PAGE = 6;
export const RESET_PASSWORD_PAGE = 7;
export const DELETE_ACCOUNT_PAGE = 8;

export const MOVE_TO_LOGIN_PAGE = "MOVE_TO_LOGIN";
export const moveToLoginPage = () => ({
  type: MOVE_TO_LOGIN_PAGE,
});

export const MOVE_TO_MAIN_PAGE = "MOVE_TO_MAIN_PAGE";
export const moveToMainPage = (doLoad) => ({
  type: MOVE_TO_MAIN_PAGE,
  doLoad,
});

export const MOVE_TO_SIGN_UP_PAGE = "MOVE_TO_SIGN_UP_PAGE";
export const moveToSignUpPage = () => ({
  type: MOVE_TO_SIGN_UP_PAGE,
});

export const MOVE_TO_VALIDATE_PAGE = "MOVE_TO_VALIDATE_PAGE";
export const moveToValidatePage = () => ({
  type: MOVE_TO_VALIDATE_PAGE,
});

export const MOVE_TO_FORGOTTEN_PAGE = "MOVE_TO_FORGOTTEN_PAGE";
export const moveToForgottenPage = () => ({
  type: MOVE_TO_FORGOTTEN_PAGE,
});

export const MOVE_TO_FORGOTTEN_PAGE_RESET = "MOVE_TO_FORGOTTEN_PAGE_RESET";
export const moveToForgottenPageReset = (email, securityQuestion) => ({
  type: MOVE_TO_FORGOTTEN_PAGE_RESET,
  email,
  securityQuestion,
});

export const MOVE_TO_OPTIONS_PAGE = "MOVE_TO_OPTIONS_PAGE";
export const moveToOptionsPage = () => ({
  type: MOVE_TO_OPTIONS_PAGE,
});

export const MOVE_TO_RESET_PASSWORD_PAGE = "MOVE_TO_RESET_PASSWORD_PAGE";
export const moveToResetPasswordPage = () => ({
  type: MOVE_TO_RESET_PASSWORD_PAGE,
});

export const MOVE_TO_DELETE_ACCOUNT_PAGE = "MOVE_TO_DELETE_ACCOUNT_PAGE";
export const moveToDeleteAccountPage = () => ({
  type: MOVE_TO_DELETE_ACCOUNT_PAGE,
});
